<template>
  <button
    v-if="hasGroups || deviceCount >= DEVICE_GROUP_ENTRY_MIN_DEVICES"
    type="button"
    class="btn btn-outline-secondary btn-sm"
    @click="$emit('click')"
  >
    <FontAwesomeIcon :icon="hasGroups ? 'plus' : 'layer-group'" class="me-1" />
    {{
      hasGroups
        ? $t("device_groups.new_group")
        : $t("device_groups.group_devices")
    }}
  </button>
</template>

<script setup lang="ts">
import { DEVICE_GROUP_ENTRY_MIN_DEVICES } from "@/dashboard/production_strategy/device_groups/deviceGroupUtils";

/**
 * The Devices tab header's way into device groups. Before the first group it is an opt-in "Group
 * devices", offered only to a company with enough devices to need groups; afterwards "New group".
 * Either opens the group modal empty.
 */
defineProps<{
  hasGroups: boolean;
  deviceCount: number;
}>();

defineEmits<{
  click: [];
}>();
</script>
